import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import axios from "axios";
import Constants from "Utils/Constants";
import Header from "Common/Header";
import AccountsTable from "./AccountsTable";
import { ToolbarButton } from "Common/ToolbarButton";
import store from "store";
import { showDialog } from "DialogProvider";
import AddAccountDialog from "./AddAccountDialog";
import { getWrappedJSON } from "Utils/Common";
import { withRouter } from "react-router-dom";
import { goToRunningTasks } from "RunningTasks";
import { goToRunningTasksAdmin } from "RunningTasksAdmin";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";

export const loadData = (user, history) => {
  return refresh().then(() => {
    history.push(Constants.accounts);
  });
};

const refresh = () => {
  var dataparams = getWrappedJSON({});
  store.dispatch({ type: "ISLOADING", payload: true });
  return axios
    .post(Constants.getaccountsApiPath, dataparams)
    .then((response) => {
      logger.log("add Tags response", response.data);
      store.dispatch({ type: "SETACCOUNTS", payload: response.data.data });
      store.dispatch({ type: "ISLOADING", payload: false });
    });
};

export class AccountsComponent extends React.Component {
  constructor(props) {
    super();
  }

  getToWallRemover = () => {
    this.props.history.push(Constants.wallremover);
  };

  addAccount = () => {
    showDialog(<AddAccountDialog />);
  };

  render = () => {
    const data = store.getState().rootScope.accounts || [];
    const user = store.getState().rootScope.user;
    const isAdmin = user.roles.isAdmin;
    const isAllowedChats = user.roles.isAllowedChats;
    let contentToRender = null;

    if (data && data.length > 0) {
      contentToRender = <AccountsTable data={data || []} />;
    } else {
      contentToRender = (
        <Paper
          elevation={3}
          style={{
            margin: "10%",
            padding: "50px",
            opacity: "70%",
            fontSize: "30px",
            fontWeight: "bold",
            backgroundColor: "var(--cardbackgroundcolor)",
          }}
        >
          No game account seems added here.
          <br />
          To begin, please add a game account through the "Add Account" button.
        </Paper>
      );
    }

    return (
      <div>
        <Header />
        <br />

        <Toolbar
          style={getStyleJSON(
            `background-color: var(--menubarbackgroundcolor);min-height: auto;`
          )}
        >
          <div layout="row" className="layout-row">
            <div>
              <ToolbarButton
                label={"Add Account"}
                onClick={this.addAccount}
                tooltip={"Click to add an account."}
              />

              <ToolbarButton
                label={"Wall Remover"}
                onClick={this.getToWallRemover}
                tooltip={"Click go to Wall Remover page."}
              />

              <ToolbarButton
                label={"Running Tasks"}
                onClick={() => goToRunningTasks(this.props.history)}
                tooltip={"Click to see all running tasks for all accounts."}
              />

              <ToolbarButton
                label={"Refresh"}
                onClick={refresh}
                tooltip={"Refresh Accounts List."}
              />
              {false && isAllowedChats && (
                <div
                  style={getStyleJSON("display:inline-block")}
                  className="ng-scope"
                >
                  <ToolbarButton
                    label={"Chat api"}
                    onClick={"goToChatApi()"}
                    tooltip={"Access Chat api."}
                  />
                </div>
              )}
              {isAdmin && (
                <div
                  style={getStyleJSON("display:inline-block")}
                  className="ng-scope"
                >
                  <ToolbarButton
                    label={"Running Tasks(Admin)"}
                    onClick={() => goToRunningTasksAdmin(this.props.history)}
                    tooltip={""}
                  />
                </div>
              )}
            </div>
          </div>
        </Toolbar>
        <br />
        {contentToRender}

        <br />
      </div>
    );
  };
}

export const Accounts = withRouter(AccountsComponent);
